export const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const URLs = {
  login: "/consortia/login",
  DashboardData: "/consortia/dashboard/get",
  studentList: "/consortia/students/get",
  changePassword: "/consortia/change_password",
  ParticipantList: "/consortia/load_all_participants",
  openPatientPortal: "/consortia/participant/get_dataviewer_url",
  getDemographicDetails: "/consortia/mgh_data/get",
  getAlsReportData: "/consortia/reports/als_non_als_report",
  get_eals_frs_list: "/consortia/participant/get_eals_frs_list",
  base_url: BASE_URL,
  BASE_URL: BASE_URL,
  get_content_library_list: "/consortia/content_library/get",
  get_slp_substudy_dashboard_counts: "/consortia/slp_substudy/dashboard/get",
  get_ecas_forms_dashboard_counts: "/consortia/ecas/dashboard/get",
  get_ecas_form_list: "/consortia/ecas/get",
  get_ecas_form_details: "/consortia/ecas/get_form_detail",
  get_feature_roadmap_list: "/consortia/feature-roadmap/get",
  save_new_feature_roadmap: "/consortia/feature-roadmap/add",
  give_vote_for_feature: "/consortia/feature-roadmap/upsert-vote",
  get_cumulative_chart_data:
    "/consortia/radcliff-study/get_radcliff_cumulative_report_data",
  get_all_demographic_chart_data:
    "/consortia/speech-study/get-all-demographics-data",
  get_radcliff_demographic_details:
    "/consortia/participant/get_radcliff_demographic_details",
  get_ares_score_list: "/consortia/participant/get_ares_score_list",
  get_radcliff_demographics_chart_data:
    "/consortia/radcliff-study/get_all_demographics_chart_data",
  get_client_code: "/consortia/participant/get_client_code",
  get_consortia_upload_list: "/consortia/consortia_uploads/get",
  add_consortia_upload: "/consortia/consortia_uploads/add",
  update_consortia_upload: "/consortia/consortia_uploads/update",
  get_total_upvote_user_list:
    "/consortia/feature-roadmap/get_total_upvote_user_list",
  get_ecas_demographic_graph_data: "/consortia/ecas/get_all_demographics_data",
  check_user_logged_for_first_time:
    "/consortia/check_user_logged_in_for_first_time",
  get_cpib_form_list: "/consortia/cpib_form/get",
  // audit logs
  view_dashboard: "/consortia/log/view_dashboard",
  view_content_library_page: "/consortia/log/view_content_library_page",
  view_consortia_workspace: "/consortia/log/view_consortia_workspace_page",
  view_add_consortia_requests: "/consortia/log/view_add_consortia_request_page",
  view_add_consortia_upload: "/consortia/log/view_add_consortia_upload_page",
  view_edit_consortia_upload_record:
    "/consortia/log/view_edit_consortia_upload_page",
  view_consortia_upload_details: "/consortia/log/view_consortia_upload_details",
  view_speech_study_report_details:
    "/consortia/log/view_speech_study_demographics_report_page_details",
  view_content_library_record_details:
    "/consortia/log/view_content_library_video",
  view_content_library_full_description:
    "/consortia/log/read_more_content_library_details",
  view_content_library_chatbot: "/consortia/log/view_content_library_chatbot",

  sendForgotPasswordOtp: "/consortia/send_verification_otp",
  verifyForgotOtp: "/consortia/verify_otp",
  resetPassword: "/consortia/reset_password",
  get_consortia_workspace_list: "/consortia/workspace/get",
  get_rapa_participant_list:"/consortia/mystudies/participantstatus",
  get_dashboard_data:"/consortia/mystudies/dashboard",
  get_reports_data:"/consortia/mystudies/reports"
};
export default URLs;
